<template><v-container class="feedback-page"><v-card outlined class="feedback-surface pa-6"><h1 class="feedback-heading">This link is no longer available</h1><p class="mt-4">Please use the link in your latest email.</p></v-card></v-container></template>
<script>
import '../../styles/feedback.scss';
export default {mounted(){delete window.pmFeedbackToken;window.history.replaceState(null,'',window.location.pathname);}};
</script>
